"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
export default function AsbestosCertificateRequest() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section className="w-full bg-light-background py-24">
      <div ref={ref} className={`mx-auto max-w-4xl px-4 text-center transition-all duration-[150ms] ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
        <h1 className="mb-4 text-4xl font-bold leading-tight text-foreground md:text-5xl">
          Asbestattest aanvragen
        </h1>
        <p className="mb-8 text-lg leading-relaxed text-muted-foreground md:text-xl">
          Vraag snel en eenvoudig uw officieel asbestattest aan. Wij staan
          klaar om u te helpen met een snelle en professionele keuring.
        </p>
        <Button size="lg" className="mb-4 transform px-8 py-4 text-base font-semibold shadow-medium transition-all duration-[120ms] ease-in-out hover:scale-[1.04] hover:shadow-strong">
          Nu aanvragen
        </Button>
        <p className="text-sm text-muted-foreground">
          Of neem contact met ons op voor meer informatie
        </p>
      </div>
    </section>;
}